import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { StoreModule } from "@ngrx/store"
import { authReducer } from "./store/auth.reducers"
import { AuthEffects } from "./store/auth.effects"
import { EffectsModule } from "@ngrx/effects"
import { AuthService } from "./auth.service"

@NgModule({
	declarations: [],
	imports: [CommonModule, StoreModule.forFeature("auth", authReducer), EffectsModule.forFeature([AuthEffects])],
	exports: [],
	providers: [AuthService]
})
export class AuthModule {}
